import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import PlayerDashboardButtons from "../../components/player-dashboard-buttons/player-dashboard-buttons";
import {getOnePlayer/*, getPlayerHomeUser*/} from "../../../modules/player";
import {getPlayerHomeSessions/*, getPlayerHomeUser*/} from "../../../modules/game_session.js";

import HomePlayForm from "./home-play-form.js";
import HomePlayBulletSection from "./home-play-bullet-section.js";
import HomePlaySessionsTable from "./home-play-sessions-table.js";
import EditProfileSection from "./edit-profile-section/edit-profile-section.js";

import CircleMemberSection from "./circle-members/circle-member-section.js";

import "./home-play.css";
class HomePlay extends Component {
    constructor(props) {
        super(props);

        this.state = {
            player_id: -1,
            invalid_player: false,
            player: false,
            home_user: false,
            home_sessions: false
        }
    }

    activationDone(home_user) {
        this.setState({
            ...this.state,
            home_user: home_user,
            player:{...this.state.player,home_user:home_user}
        })
    }

    updateHomeUser(homeUser) {
        let {player} = this.state;


        let newPlayer = {...player};

        newPlayer.home_user = homeUser;
        this.setState({
            home_user: homeUser,
            player: newPlayer
        });
    }

    async componentDidMount() {
        let {token} = this.props;
        let playerID = this.props.match.params.id;
        let playerResponse = await getOnePlayer(playerID, token);
        console.log("   ~~~ HomePlay.componentDidMount")
        console.log(playerResponse)

        if (playerResponse.data.success) {

            let playerData = playerResponse.data.player_data;
            this.setState({player_id: playerID, player: playerData, home_user: playerData.home_user});
        }
        else {
            this.setState({invalid_player: true});
        }   
        let homeSessionsResponse = await getPlayerHomeSessions(playerID, token);

        if (homeSessionsResponse.data.success) {
            let homeSessions = homeSessionsResponse.data.home_sessions;
            this.setState({home_sessions: homeSessions});
        }

    }

    render() {        

        let {player, invalid_player, home_user, home_sessions} = this.state;
        let {token} = this.props;

        let gotPlayer = false;
        if (player) {
            gotPlayer = true;
        }

        let activateHomePlayClass = "activate_home_play";
        
        let hasHomeUser = false;
        if (home_user) {
            hasHomeUser = true;
            activateHomePlayClass += " hide";
        }

        return (
            <div className='home_play_container'>
                {gotPlayer && (
                    <PlayerDashboardButtons player={player} activePage="homePlay" isTherapistRole={this.props.isTherapistRole} />
                )}

                {gotPlayer && !hasHomeUser &&
                    <div className={activateHomePlayClass}>
                        <HomePlayBulletSection /><HomePlayForm player={player} token={token} activation_done={this.activationDone.bind(this)}/>
                    </div>
                }   

                {gotPlayer && hasHomeUser && <EditProfileSection player={player} token={token} update_home_user={this.updateHomeUser.bind(this)}/>}

                {hasHomeUser && 
                    <CircleMemberSection player={player} home_user={home_user} token={token} />
                }

                {gotPlayer && <HomePlaySessionsTable sessions={home_sessions} player={player}/>}
                {invalid_player && <div>Invalid Player</div>}
            </div>

        )
    }
}


const withState = connect(state => {
    const {user} = state;

    return {
        token: user.token,
        isTherapistRole: user.isTherapistRole
    };
});



export default withRouter(withState(HomePlay));


// WEBPACK FOOTER //
// ./src/components/containers/home-play/home-play.js